import { match, P } from 'ts-pattern';

type TeamRecord = { wins?: number; losses?: number; ties?: number };
type TeamRecordFormat = 'W-L-T' | 'W-D-L';

const getRecordValues = (record: TeamRecord, format: TeamRecordFormat) =>
  match(format)
    .with('W-D-L', () => [record.wins ?? 0, record.ties ?? 0, record.losses ?? 0])
    .with('W-L-T', () =>
      match(record.ties)
        .with(P.number, (ties) => [record.wins, record.losses, ties])
        .otherwise(() => [record.wins, record.losses])
    )
    .exhaustive();

export function formatTeamRecord(record: TeamRecord, format?: TeamRecordFormat): string;
export function formatTeamRecord(
  record?: TeamRecord,
  format?: TeamRecordFormat
): string | undefined;
export function formatTeamRecord(record?: TeamRecord, format: TeamRecordFormat = 'W-L-T') {
  return match(record)
    .with(undefined, () => undefined)
    .with(P.not(undefined), (teamRecord) => getRecordValues(teamRecord, format).join('-'))
    .exhaustive();
}
